import { AxiosError } from 'axios';
import { restApi } from 'src/utilities/restApi';
import { ResponseGetPrsItemSettings } from 'src/utilities/restApi/common/types/prsitemsettings';
import { ErrorResponse, SuccessResponse } from 'src/utilities/restApi/common/types/responses';
import { getCommonHeaders } from 'src/utilities/restApi/utilities/getCommonHeader';

export const getPrsItemSettings = async () => {
  const headers = { headers: await getCommonHeaders() };
  const config = { ...headers };

  return new Promise<SuccessResponse<ResponseGetPrsItemSettings>>((resolve, reject) => {
    restApi()
      .get<SuccessResponse<ResponseGetPrsItemSettings>>('prsitemsettings', config)
      .then((response) => resolve(response.data!))
      .catch((error: AxiosError<ErrorResponse>) => reject(error.response?.data));
  });
};
